/**
 * Builds the party-member quantities stored in checkout state for a unit.
 * Mandatory party members must be present in state as well as clamped in the UI,
 * otherwise the initial summary can omit values that the steppers display as 1.
 *
 * @param {Array<object>} partyMembers
 * @param {number|string} unitId
 * @param {object|null} quantitiesById
 * @returns {object}
 */
export function buildInitialPartyMembersForUnit(partyMembers, unitId, quantitiesById = null) {
    const unitKey = `u${unitId}`;

    return partyMembers
        .filter(partyMember => partyMember.units.includes(unitKey))
        .reduce((partyMemberObject, partyMember, index) => {
            const mandatoryMinimum = parseInt(partyMember.mandatory, 10) > 0 ? 1 : 0;
            const presetQuantity = quantitiesById === null
                ? null
                : parseInt(quantitiesById[partyMember.id] ?? 0, 10) || 0;
            const defaultQuantity = index === 0 ? 1 : mandatoryMinimum;

            partyMemberObject[`_${partyMember.id}`] = {
                qty: presetQuantity === null
                    ? Math.max(defaultQuantity, mandatoryMinimum)
                    : Math.max(presetQuantity, mandatoryMinimum),
                calc_include: parseInt(partyMember.calc_include, 10) || 0
            };

            return partyMemberObject;
        }, {});
}
